import React, { useEffect, useState } from 'react';
import _noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import DottedDropDown from '../../../../components/DottedDropdown/DottedDropdown';
import RenameTeamModal from '../ActionComponents/RenameTeamModal';
import DeleteTeamModal from '../ActionComponents/DeleteTeamModal';
import AddMealPlanModal from '../ActionComponents/AddMealPlanModal';
import AddEmployeesModal from '../ActionComponents/AddEmployeesModal';
import { DottedActionBtnWrapper } from '../../../common/styles';
import {
  applicableFlowTypes,
  currentFlowTypeEnum,
} from '../../../common/components/constants';

const ActionGroupsTable = ({
  data,
  currentFlow,
  selectedWorkspace,
  getAllGroups,
  getEmployeeSection,
  viewOnlyMode,
}) => {
  const options = [
    {
      label: 'Add employees',
      value: 'add_employees',
      isActive: true && !viewOnlyMode,
    },
    {
      label: 'Add meal plan',
      value: 'add_meal_plan',
      isActive: data.can_plan_be_mapped && !viewOnlyMode,
    },
    // {
    //   label: 'Rename Team',
    //   value: 'rename_team',
    // },
    // {
    //   label: 'Delete Team',
    //   value: 'delete_team',
    // },
  ];

  const [selectedOption, setSelectedOption] = useState(null);
  const [isRenameTeamModalVisible, setIsRenameTeamModalVisible] = useState(
    false,
  );
  const [isDeleteTeamModalVisible, setIsDeleteTeamModalVisible] = useState(
    false,
  );
  const [isAddMealPlanModalVisible, setIsAddMealPlanModalVisible] = useState(
    false,
  );
  const [isAddEmployeeModalVisible, setIsAddEmployeeModalVisible] = useState(
    false,
  );

  const closeDeleteTeamModal = () => {
    setIsDeleteTeamModalVisible(false);
  };

  const closeRenameTeamModal = () => {
    setIsRenameTeamModalVisible(false);
  };

  const closeAddMealPlanModal = () => {
    setIsAddMealPlanModalVisible(false);
  };

  const closeAddEmployeeModal = () => {
    setIsAddEmployeeModalVisible(false);
    getAllGroups({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
    getEmployeeSection({
      workspaceId: selectedWorkspace.workspace_id,
      flowType: currentFlow,
    });
  };

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption.value) {
        case 'add_meal_plan':
          setIsAddMealPlanModalVisible(true);
          break;
        case 'add_employees':
          setIsAddEmployeeModalVisible(true);
          break;
        case 'rename_team':
          setIsRenameTeamModalVisible(true);
          break;
        case 'delete_team':
          setIsDeleteTeamModalVisible(true);
          break;
        default:
          console.log(data);
      }
      setSelectedOption(null);
    }
  }, [selectedOption]);

  return (
    <DottedActionBtnWrapper>
      <DottedDropDown options={options} setSelectedOption={setSelectedOption} />
      {isRenameTeamModalVisible && !viewOnlyMode && (
        <RenameTeamModal
          isVisible={isRenameTeamModalVisible}
          closeModal={closeRenameTeamModal}
          heading='Rename team'
          teamData={data}
        />
      )}
      {isDeleteTeamModalVisible && !viewOnlyMode && (
        <DeleteTeamModal
          isVisible={isDeleteTeamModalVisible}
          closeModal={closeDeleteTeamModal}
          teamData={data}
        />
      )}
      {isAddMealPlanModalVisible &&
        !viewOnlyMode &&
        data.can_plan_be_mapped && (
          <AddMealPlanModal
            group={data}
            isVisible={isAddMealPlanModalVisible}
            closeModal={closeAddMealPlanModal}
          />
        )}
      {isAddEmployeeModalVisible && !viewOnlyMode && (
        <AddEmployeesModal
          group={data}
          isVisible={isAddEmployeeModalVisible}
          closeModal={closeAddEmployeeModal}
        />
      )}
    </DottedActionBtnWrapper>
  );
};

ActionGroupsTable.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  getAllGroups: PropTypes.func,
  getEmployeeSection: PropTypes.func,
  viewOnlyMode: PropTypes.bool,
};

ActionGroupsTable.defaultProps = {
  data: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  selectedWorkspace: {},
  getAllGroups: _noop,
  getEmployeeSection: _noop,
  viewOnlyMode: false,
};

export default ActionGroupsTable;
